import * as DSAssetFamilies from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import get from 'transmute/get';
import { EVENT_BASED_FIELD_KEYS } from '../strategy/eventBasedFilters';
import I18n from 'I18n';
import { __ANY_PAGE } from 'customer-data-filters-ui/converters/listSegClassic/ListSegConstants';
import getIn from 'transmute/getIn';
import FormNotFilledOut from 'customer-data-filters-ui/filterQueryFormat/operator/FormNotFilledOut';
import { isPropertyChangedEventTypeId, isPropertyNameAndValueCondition } from '../strategy/propertyChangedFilterUtils';
import PropertyChangedNameAndValueField from '../converters/objectSeg/fieldDefinitions/PropertyChangedNameAndValueField';
import { DATE_REFINEMENT, NUMBER_REFINEMENT } from 'customer-data-filters-ui/converters/objectSeg/constants/constants';
const operatorsIncompatibleWithNumberOfTimesRefinement = Object.freeze({
  [DSAssetFamilies.FORM]: Object.freeze({
    [FormNotFilledOut.toString()]: true
  })
});
const getConflictingRefinementFieldsTooltips = (filterFamily, condition) => {
  if (!condition) {
    return {};
  }
  const operatorName = condition.constructor.toString();
  if (getIn([filterFamily, operatorName], operatorsIncompatibleWithNumberOfTimesRefinement)) {
    return {
      [EVENT_BASED_FIELD_KEYS.EVENT_COUNT]: I18n.text(`newCustomerDataFilters.fieldDisabledTooltip.${filterFamily}.hs_event_count.${operatorName}`)
    };
  }
  return {};
};
export const FILTER_FAMILIES_WITHOUT_MULTIPLE_REFINEMENTS = Object.freeze([DSAssetFamilies.PAGE_VIEW, DSAssetFamilies.CTA, DSAssetFamilies.EVENT]);
const getActiveRefinementFieldsTooltips = (filterFamily, condition) => {
  if (FILTER_FAMILIES_WITHOUT_MULTIPLE_REFINEMENTS.includes(filterFamily)) {
    if (condition !== null && condition !== void 0 && condition.dateRefinement) {
      return {
        [EVENT_BASED_FIELD_KEYS.EVENT_DATE]: I18n.text('newCustomerDataFilters.fieldDisabledTooltip.refinementAlreadySelected'),
        [EVENT_BASED_FIELD_KEYS.EVENT_COUNT]: I18n.text(`newCustomerDataFilters.fieldDisabledTooltip.${filterFamily}.hs_event_count.dateRefinementSelected`)
      };
    }
    if (condition !== null && condition !== void 0 && condition.numberRefinement) {
      return {
        [EVENT_BASED_FIELD_KEYS.EVENT_DATE]: I18n.text(`newCustomerDataFilters.fieldDisabledTooltip.${filterFamily}.hs_event_date.countRefinementSelected`),
        [EVENT_BASED_FIELD_KEYS.EVENT_COUNT]: I18n.text(`newCustomerDataFilters.fieldDisabledTooltip.refinementAlreadySelected`)
      };
    }
  }
  return {
    [EVENT_BASED_FIELD_KEYS.EVENT_DATE]: getIn([DATE_REFINEMENT], condition) ? I18n.text('newCustomerDataFilters.fieldDisabledTooltip.refinementAlreadySelected') : undefined,
    [EVENT_BASED_FIELD_KEYS.EVENT_COUNT]: getIn([NUMBER_REFINEMENT], condition) ? I18n.text(`newCustomerDataFilters.fieldDisabledTooltip.refinementAlreadySelected`) : undefined
  };
};
const getActivePageFieldTooltip = (__condition, isPageSelected) => {
  if (isPageSelected) {
    return {
      [EVENT_BASED_FIELD_KEYS.EVENT_PAGE]: I18n.text('newCustomerDataFilters.fieldDisabledTooltip.refinementAlreadySelected')
    };
  }
  return {};
};
const getFormActiveFieldsTooltips = (filterFamily, condition) => {
  const isPageSelected = get('value', condition) !== __ANY_PAGE || get('isPageSelected', condition);
  const activeFieldsTooltips = Object.assign({}, getActiveRefinementFieldsTooltips(filterFamily, condition), getConflictingRefinementFieldsTooltips(filterFamily, condition), getActivePageFieldTooltip(condition, !!isPageSelected));
  return activeFieldsTooltips;
};
const getPageViewActiveFieldsTooltips = (filterFamily, condition) => {
  const activeFieldsTooltips = Object.assign({}, getActiveRefinementFieldsTooltips(filterFamily, condition));
  return activeFieldsTooltips;
};
const getMarketingEmailActiveFieldsTooltips = (filterFamily, condition) => {
  const activeFieldsTooltips = Object.assign({}, getActiveRefinementFieldsTooltips(filterFamily, condition));
  return activeFieldsTooltips;
};
const getCtaActiveFieldsTooltips = (filterFamily, condition) => {
  const activeFieldsTooltips = Object.assign({}, getActiveRefinementFieldsTooltips(filterFamily, condition));
  return activeFieldsTooltips;
};
const getBehavioralEventActiveFieldsTooltips = (filterFamily, condition) => {
  const activeFieldsTooltips = Object.assign({}, getActiveRefinementFieldsTooltips(filterFamily, condition));
  return activeFieldsTooltips;
};
const getPropertyValueChangedActiveFieldsTooltips = logicGroup => {
  if (logicGroup && logicGroup.conditions.some(value => isPropertyNameAndValueCondition(value))) {
    return {
      [PropertyChangedNameAndValueField().name]: I18n.text('newCustomerDataFilters.fieldDisabledTooltip.filterAlreadySelected')
    };
  }
  return {};
};
export const getActiveFieldsTooltips = (filterFamily, filterTarget) => {
  if (filterFamily === DSAssetFamilies.FORM) {
    return getFormActiveFieldsTooltips(filterFamily, filterTarget);
  }
  if (filterFamily === DSAssetFamilies.PAGE_VIEW) {
    return getPageViewActiveFieldsTooltips(filterFamily, filterTarget);
  }
  if (filterFamily === DSAssetFamilies.EMAIL_CAMPAIGN) {
    return getMarketingEmailActiveFieldsTooltips(filterFamily, filterTarget);
  }
  if (filterFamily === DSAssetFamilies.CTA) {
    return getCtaActiveFieldsTooltips(filterFamily, filterTarget);
  }
  if (filterFamily === DSAssetFamilies.EVENT) {
    return getBehavioralEventActiveFieldsTooltips(filterFamily, filterTarget);
  }
  if (isPropertyChangedEventTypeId(filterFamily)) {
    return getPropertyValueChangedActiveFieldsTooltips(filterTarget);
  }
  return {};
};